import { SvgIcon } from "@mui/material"

import { ReactComponent as Focus } from "./Focus.svg"

export const FocusIcon = (props) => {
    return (
        <SvgIcon component={Focus} {...props} inheritViewBox />
    )
}